// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1DcaV","actions":"styles_actions__3IFbC","btn":"styles_btn__1pzw6","error":"styles_error__3lYLV"};